/* Le Clos: event kit preview. Renders the first pages of the kit PDF so guests can leaf through it before downloading. */
(function () {
  'use strict';
  var root = document.querySelector('[data-kit]');
  if (!root) return;
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
  var src = root.dataset.src, free = Math.max(1, Number(root.dataset.free) || 6);
  var $ = function (s) { return root.querySelector(s); };
  var stage = $('[data-kit-stage]'), thumbs = $('[data-kit-thumbs]'), titleEl = $('[data-kit-title]'), countEl = $('[data-kit-count]');
  var lock = $('[data-kit-lock]'), prev = $('[data-kit-prev]'), next = $('[data-kit-next]');
  var doc = null, total = 0, shown = 0, cur = 0, slides = [], titles = [], started = false;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function loadScript(u) { return new Promise(function (ok, ko) { var s = document.createElement('script'); s.src = u; s.onload = ok; s.onerror = ko; document.head.appendChild(s); }); }

  /* The biggest line of text on a page is its title ("About us", "Space overview"). */
  function pageTitle(page) {
    return page.getTextContent().then(function (tc) {
      var best = 0, words = [];
      tc.items.forEach(function (it) { var h = Math.abs(it.transform[3]); if (it.str.trim() && h > best + 0.5) { best = h; words = [it.str]; } else if (it.str.trim() && Math.abs(h - best) <= 0.5) words.push(it.str); });
      var t = words.join(' ').replace(/\s+/g, ' ').trim();
      if (t.length > 42 || t.length < 3) return '';
      return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase().replace(/\ble clos\b/g, 'Le Clos');
    }).catch(function () { return ''; });
  }

  function render(n) {
    return doc.getPage(n).then(function (page) {
      var base = page.getViewport({ scale: 1 });
      var w = Math.min(1500, Math.round(stage.clientWidth * Math.min(window.devicePixelRatio || 1, 2)) || 900);
      if (phone.matches) w = Math.min(1600, Math.max(w, 1400));
      var vp = page.getViewport({ scale: w / base.width });
      var c = document.createElement('canvas');
      c.width = Math.round(vp.width); c.height = Math.round(vp.height);
      if (n === 1) stage.style.setProperty('--ar', base.width + ' / ' + base.height);
      return Promise.all([page.render({ canvasContext: c.getContext('2d', { alpha: false }), viewport: vp }).promise, pageTitle(page)]).then(function (r) {
        titles[n] = r[1];
        return new Promise(function (ok) { c.toBlob(function (b) { ok(URL.createObjectURL(b)); }, 'image/jpeg', 0.86); });
      });
    });
  }

  function setSlide(i, img) {
    var s = slides[i];
    s.img.src = img; s.img.alt = 'Event kit, page ' + (i + 1) + (titles[i + 1] ? ': ' + titles[i + 1] : '');
    s.thumb.querySelector('img').src = img;
    s.thumb.classList.remove('is-wait'); s.el.classList.remove('is-wait');
    if (i === 0) root.classList.add('has-first');
    if (fv && !fv.hidden) full();
    var cap = s.thumb.querySelector('span'); if (titles[i + 1]) cap.textContent = titles[i + 1];
    if (i === cur) label();
  }

  function build() {
    shown = Math.min(free, total);
    var more = total - shown;
    for (var i = 0; i < shown; i++) {
      var el = document.createElement('figure'); el.className = 'lce-kit__slide is-wait'; el.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img'); img.decoding = 'async'; el.appendChild(img); stage.insertBefore(el, lock);
      var t = document.createElement('button'); t.type = 'button'; t.className = 'lce-kit__thumb is-wait'; t.dataset.go = i;
      t.setAttribute('aria-label', 'Page ' + (i + 1));
      t.innerHTML = '<img alt=""><b>' + pad(i + 1) + '</b><span></span>';
      thumbs.appendChild(t);
      slides.push({ el: el, img: img, thumb: t });
    }
    if (more > 0) {
      var lt = document.createElement('button'); lt.type = 'button'; lt.className = 'lce-kit__thumb lce-kit__thumb--more'; lt.dataset.go = shown;
      lt.innerHTML = '<img alt=""><b>+' + more + '</b><span>More inside</span>';
      thumbs.appendChild(lt);
      $('[data-kit-more]').textContent = more + ' more ' + (more === 1 ? 'page' : 'pages') + ' inside.';
    }
    root.classList.add('is-ready');
    go(0);
  }

  function label() {
    if (cur >= shown) { titleEl.textContent = 'The rest of the kit'; countEl.textContent = pad(shown + 1) + ' to ' + pad(total) + ' / ' + pad(total); return; }
    titleEl.textContent = titles[cur + 1] || (cur === 0 ? 'Cover' : '');
    countEl.textContent = pad(cur + 1) + ' / ' + pad(total);
  }

  function go(i) {
    var last = total > shown ? shown : shown - 1;
    i = Math.max(0, Math.min(last, i));
    cur = i;
    slides.forEach(function (s, k) { var on = k === i; s.el.classList.toggle('is-on', on); s.el.classList.toggle('is-past', k < i); s.thumb.setAttribute('aria-current', on ? 'true' : 'false'); });
    var lt = thumbs.querySelector('.lce-kit__thumb--more'); if (lt) lt.setAttribute('aria-current', i >= shown ? 'true' : 'false');
    lock.hidden = i < shown; lock.classList.toggle('is-on', i >= shown);
    root.classList.toggle('is-locked', i >= shown);
    prev.disabled = i === 0; next.disabled = i === last;
    var act = thumbs.querySelector('[aria-current="true"]');
    if (act) thumbs.scrollTo({ left: act.offsetLeft - (thumbs.clientWidth - act.clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    label();
  }

  function start() {
    if (started) return; started = true;
    root.classList.add('is-loading');
    loadScript(PDFJS + 'pdf.min.js').then(function () {
      var lib = window.pdfjsLib; lib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
      return lib.getDocument({ url: src, disableAutoFetch: true, disableStream: true, rangeChunkSize: 262144 }).promise;
    }).then(function (d) {
      doc = d; total = d.numPages; build();
      /* Render the cover first, then the rest in order, then a blurred glimpse of the next page. */
      var chain = Promise.resolve();
      for (var n = 1; n <= shown; n++) (function (n) { chain = chain.then(function () { return render(n).then(function (u) { setSlide(n - 1, u); }); }); })(n);
      if (total > shown) chain = chain.then(function () { return render(shown + 1).then(function (u) { $('[data-kit-glimpse]').src = u; var lt = thumbs.querySelector('.lce-kit__thumb--more img'); if (lt) lt.src = u; }); });
      return chain;
    }).then(function () { root.classList.remove('is-loading'); }).catch(function () {
      root.classList.remove('is-loading'); root.classList.add('is-failed');
    });
  }

  /* Phones: tap a page to read it full screen. In portrait the page is turned sideways to fill the screen. */
  var phone = window.matchMedia('(max-width: 699px)'), fv = null;
  var css = '.lce-fv{position:fixed;inset:0;z-index:200;display:flex;flex-direction:column;background:#1E2420;color:#FAF5F0;touch-action:none}' +
    '.lce-fv[hidden]{display:none!important}' +
    '.lce-fv__top{display:flex;justify-content:space-between;align-items:center;padding:calc(10px + env(safe-area-inset-top)) 12px 6px 20px;font:500 11px/1 Quicksand,system-ui,sans-serif;letter-spacing:.18em}' +
    '.lce-fv__x{width:44px;height:44px;border:0;background:none;color:inherit;display:grid;place-items:center;cursor:pointer}' +
    '.lce-fv__img{position:relative;flex:1;display:grid;place-items:center;overflow:hidden}' +
    '.lce-fv__img img{display:block;width:100%;height:auto;max-height:100%;object-fit:contain}' +
    '.lce-fv__foot{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:8px 16px calc(14px + env(safe-area-inset-bottom))}' +
    '.lce-fv__foot button{width:48px;height:48px;border:1px solid rgba(250,245,240,.35);border-radius:50%;background:none;color:inherit;display:grid;place-items:center;cursor:pointer}' +
    '.lce-fv__foot button:disabled{opacity:.25}' +
    '.lce-fv__hint{margin:0;font:italic 400 15px/1.3 "EB Garamond",Garamond,serif;color:rgba(250,245,240,.75);text-align:center}' +
    '@media (orientation:portrait){.lce-fv__img img{position:absolute;left:50%;top:50%;width:min(calc(100dvh - 170px),172vw);max-width:none;max-height:none;transform:translate(-50%,-50%) rotate(90deg)}}' +
    '@media (orientation:landscape){.lce-fv__hint{display:none}}' +
    '.lce-kit.is-ready:not(.has-first) .lce-kit__ph{opacity:1}' +
    '@media (max-width:699px){.lce-kit__view{width:100vw;margin-left:calc(50% - 50vw)}.lce-kit__stage{border-radius:0;box-shadow:none}.lce-kit__bar{padding:0 20px}.lce-kit__grid>*{min-width:0}.lce-kit__thumbs{padding:4px 20px 10px!important;scrollbar-width:none!important}.lce-kit__thumbs::-webkit-scrollbar{display:none}.lce-kit__nav{opacity:1}' +
    '.lce-kit__stage::after{content:"Tap to read";position:absolute;right:12px;bottom:12px;padding:7px 12px;border-radius:999px;background:rgba(250,245,240,.92);font:500 10px/1 Quicksand,system-ui,sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#3A4937;pointer-events:none;z-index:1}' +
    '.lce-kit:not(.has-first) .lce-kit__stage::after,.lce-kit.is-locked .lce-kit__stage::after{display:none}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var ARROW = function (d) { return '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="' + (d < 0 ? 'M11 3L5 9l6 6' : 'M7 3l6 6-6 6') + '" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>'; };
  function full() {
    var i = Math.min(cur, shown - 1), s = slides[i];
    fv.querySelector('img').src = s.img.src; fv.querySelector('img').alt = s.img.alt;
    fv.querySelector('[data-fv-count]').textContent = pad(i + 1) + ' / ' + pad(total);
    fv.querySelector('[data-fv-prev]').disabled = i === 0;
  }
  function step(d) {
    if (cur + d >= shown) { closeFull(); go(shown); stage.scrollIntoView({ block: 'center' }); return; }
    go(cur + d); full();
  }
  function closeFull() { if (!fv || fv.hidden) return; fv.hidden = true; document.documentElement.style.overflow = ''; }
  function openFull() {
    if (!fv) {
      fv = document.createElement('div'); fv.className = 'lce-fv'; fv.hidden = true;
      fv.setAttribute('role', 'dialog'); fv.setAttribute('aria-modal', 'true'); fv.setAttribute('aria-label', 'Event kit');
      fv.innerHTML = '<div class="lce-fv__top"><span data-fv-count></span><button type="button" class="lce-fv__x" data-fv-close aria-label="Close"><svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.4"/></svg></button></div>' +
        '<div class="lce-fv__img"><img alt=""></div>' +
        '<div class="lce-fv__foot"><button type="button" data-fv-prev aria-label="Previous page">' + ARROW(-1) + '</button><p class="lce-fv__hint">Turn your phone to read</p><button type="button" data-fv-next aria-label="Next page">' + ARROW(1) + '</button></div>';
      document.body.appendChild(fv);
      fv.querySelector('[data-fv-close]').addEventListener('click', closeFull);
      fv.querySelector('[data-fv-prev]').addEventListener('click', function () { step(-1); });
      fv.querySelector('[data-fv-next]').addEventListener('click', function () { step(1); });
      var fx = null, fy = 0;
      fv.addEventListener('touchstart', function (e) { fx = e.touches[0].clientX; fy = e.touches[0].clientY; }, { passive: true });
      fv.addEventListener('touchend', function (e) {
        if (fx === null) return; var dx = e.changedTouches[0].clientX - fx, dy = e.changedTouches[0].clientY - fy; fx = null;
        var turned = window.matchMedia('(orientation: portrait)').matches, d = turned ? dy : dx, o = turned ? dx : dy;
        if (Math.abs(d) > 40 && Math.abs(d) > Math.abs(o)) step(d < 0 ? 1 : -1);
      }, { passive: true });
      document.addEventListener('keydown', function (e) { if (fv.hidden) return; if (e.key === 'Escape') closeFull(); if (e.key === 'ArrowRight') step(1); if (e.key === 'ArrowLeft') step(-1); });
    }
    full(); fv.hidden = false; document.documentElement.style.overflow = 'hidden';
    fv.querySelector('[data-fv-close]').focus();
  }

  /* Controls */
  prev.addEventListener('click', function () { go(cur - 1); });
  next.addEventListener('click', function () { go(cur + 1); });
  thumbs.addEventListener('click', function (e) { var b = e.target.closest('[data-go]'); if (b) go(Number(b.dataset.go)); });
  stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { go(cur + 1); e.preventDefault(); } if (e.key === 'ArrowLeft') { go(cur - 1); e.preventDefault(); } });
  stage.addEventListener('click', function (e) {
    if (e.target.closest('button,a')) return;
    if (phone.matches) { if (cur < shown && slides[cur] && slides[cur].img.src) openFull(); return; }
    var r = stage.getBoundingClientRect(); go(e.clientX - r.left > r.width / 2 ? cur + 1 : cur - 1);
  });
  var x0 = null, y0 = 0;
  stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? cur + 1 : cur - 1);
  }, { passive: true });

  /* At the top of the page the kit opens straight away; further down, only when the guest gets close. */
  if (root.getBoundingClientRect().top < (window.innerHeight || 800) * 1.5) start();
  else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '600px 0px' });
    io.observe(root);
  } else start();
  document.addEventListener('click', function (e) { if (e.target.closest('a[href="#kit"]')) start(); });
})();
